export function getTreemapAlerts(): string[] {
  const alerts: string[] = [];
  // No specific alerts for treemap chart
  return alerts;
}
